export enum QuestionStyle {
  PLAIN = 'plain',
  RADIO = 'radio',
  TEXTAREA = 'textarea',
  TEXT = 'text',
  SCORE = 'score',
  CHECKLIST = 'checklist',
  CUSTOMERSCHEMA = 'customer_schema',
  AGREEMENT = 'agreement',
  NAMING = 'naming',
  PHONENUMBER = 'phone_number',
  MATRIX = 'matrix',
  DATEPICKER = 'datepicker',
  NUMERIC = 'numeric',
  AGE = 'age',
  EXTERNALID = 'external_id',
  STAR = 'star',
  SLIDER = 'slider',
  DROPDOWN = 'dropdown',
  HIDDENVALIDATION = 'hidden_validation',
  GENDER = 'gender',
  EMAIL = 'email',
  RANKING = 'ranking',
  FILE = 'file',
  RANDOM = 'random',
  PHONEVERIFICATION = 'phone_verification',
  DYNAMICREQUEST = 'dynamic_request',
  LOCATION = 'location',
  QRCODE = 'qr_code',
  SCREENSHOT = 'screenshot',
}
